<div class="ayudas-page">
    <!-- Header de página (mismo estilo que Liquidaciones VD) -->
    <div class="page-header">
        <h1 class="page-title">AYUDAS</h1>
        <p class="page-subtitle text-muted">
            Manuales, documentos y tutoriales disponibles
        </p>
    </div>

    <mat-card class="data-card">
        <mat-card-content>
            <div *ngIf="isLoading" class="loading-container">
                <div class="loading-spinner">
                    <mat-spinner diameter="40"></mat-spinner>
                    <p>Cargando ayudas...</p>
                </div>
            </div>

            <ng-container *ngIf="!isLoading">
                <!-- Sección: Manuales y documentos disponibles -->
                <section class="ayudas-section" *ngIf="documentos.length > 0">
                    <h2 class="section-title">Manuales y documentos disponibles</h2>
                    <div class="cards-row">
                        <mat-card
                            *ngFor="let ayuda of documentos; trackBy: trackByAyudaId"
                            class="ayuda-card ayuda-card--documento">
                            <mat-card-content class="card-content">
                                <i-feather name="file-text" class="card-icon card-icon--doc"></i-feather>
                                <div class="card-body">
                                    <span class="card-title">{{ ayuda.titulo }}</span>
                                    <div class="card-actions">
                                        <span class="card-badge" [class.card-badge--pdf]="(ayuda.tipoDocumento || 'pdf').toLowerCase() === 'pdf'" [class.card-badge--docx]="(ayuda.tipoDocumento || '').toLowerCase() === 'docx'">{{ (ayuda.tipoDocumento || 'pdf').toUpperCase() }}</span>
                                        <button
                                            mat-icon-button
                                            [matMenuTriggerFor]="docMenu"
                                            class="card-menu-btn"
                                            [attr.aria-label]="'Opciones de ' + ayuda.titulo">
                                            <mat-icon>arrow_drop_down</mat-icon>
                                        </button>
                                        <mat-menu #docMenu="matMenu" xPosition="before">
                                            <button mat-menu-item (click)="downloadAyuda(ayuda)">
                                                <mat-icon>download</mat-icon>
                                                <span>Descargar</span>
                                            </button>
                                        </mat-menu>
                                    </div>
                                </div>
                            </mat-card-content>
                        </mat-card>
                    </div>
                </section>

                <!-- Sección: Tutoriales disponibles -->
                <section class="ayudas-section" *ngIf="videos.length > 0">
                    <h2 class="section-title">Tutoriales disponibles</h2>
                    <div class="cards-row">
                                <mat-card
                            *ngFor="let ayuda of videos; trackBy: trackByAyudaId"
                            class="ayuda-card ayuda-card--video">
                            <mat-card-content class="card-content">
                                <i-feather name="play-circle" class="card-icon card-icon--video"></i-feather>
                                <div class="card-body">
                                    <span class="card-title">{{ ayuda.titulo }}</span>
                                    <div class="card-actions">
                                        <span class="card-badge card-badge--video">Video</span>
                                        <button
                                            mat-icon-button
                                            [matMenuTriggerFor]="videoMenu"
                                            class="card-menu-btn"
                                            [attr.aria-label]="'Opciones de ' + ayuda.titulo">
                                            <mat-icon>arrow_drop_down</mat-icon>
                                        </button>
                                        <mat-menu #videoMenu="matMenu" xPosition="before">
                                            <button mat-menu-item (click)="openVideoModal(ayuda)">
                                                <mat-icon>play_circle</mat-icon>
                                                <span>Reproducir</span>
                                            </button>
                                            <button mat-menu-item (click)="openVideoInNewTab(ayuda)">
                                                <mat-icon>open_in_new</mat-icon>
                                                <span>Abrir en YouTube</span>
                                            </button>
                                        </mat-menu>
                                    </div>
                                </div>
                            </mat-card-content>
                        </mat-card>
                    </div>
                </section>

                <div *ngIf="!isLoading && documentos.length === 0 && videos.length === 0" class="empty-state">
                    <i-feather name="info" class="empty-icon"></i-feather>
                    <p class="empty-message">No hay ayudas disponibles en este momento.</p>
                </div>
            </ng-container>
        </mat-card-content>
    </mat-card>
</div>

<!-- Modal para reproducir video (estilo OPB) -->
<dialog
    class="video-modal"
    #videoDialog
    (click)="closeVideoModal($event)"
    (keydown.escape)="closeVideoModal($event)">
    <div
        class="video-modal-content"
        (click)="$event.stopPropagation()"
        (keydown.escape)="closeVideoModal($event)">
        <header class="video-modal-header">
            <h2 class="video-modal-header-title">{{ videoEnReproduccion?.titulo || 'Tutorial' }}</h2>
            <button
                mat-icon-button
                class="video-modal-close"
                (click)="closeVideoModal($event)"
                aria-label="Cerrar">
                <mat-icon>close</mat-icon>
            </button>
        </header>
        <div class="video-modal-body" *ngIf="videoEnReproduccion">
            <div class="video-modal-iframe-wrap">
                <iframe
                    *ngIf="getYouTubeEmbedUrl(videoEnReproduccion.urlOrPath)"
                    [src]="getYouTubeEmbedUrl(videoEnReproduccion.urlOrPath)"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowfullscreen
                    title="Video tutorial">
                </iframe>
            </div>
        </div>
    </div>
</dialog>
